import React from 'react';
import { getIconForSymbol } from './blockchainIcons';
import { formatUSD, formatRelativeTime } from './dashboardFormat';
import SeedPhraseReveal from './SeedPhraseReveal';

const RecentFindsList = ({ finds }) => {
  if (!finds || finds.length === 0) {
    return (
      <div className="dash-chart-card">
        <span className="dash-chart-card-title">Recent Finds</span>
        <div className="dash-chart-empty">No wallets found yet.</div>
      </div>
    );
  }

  return (
    <div className="dash-chart-card">
      <span className="dash-chart-card-title">Recent Finds</span>
      <div className="dash-recent-finds">
        {finds.map((find) => {
          const icon = getIconForSymbol(find.symbol);
          return (
            <div className="dash-recent-find-row" key={find.id}>
              <div className="dash-recent-find-identity">
                {icon && <img src={icon} alt="" className="dash-recent-find-icon" draggable="false" />}
                <span className="dash-recent-find-symbol">{find.symbol}</span>
              </div>
              <span className="dash-recent-find-balance">{formatUSD(find.balance)}</span>
              <span className="dash-recent-find-time">{formatRelativeTime(find.timestamp)}</span>
              <SeedPhraseReveal words={find.words} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentFindsList;
